import React from "react";
import { Box } from "@mui/material";
import TeamVirtualOfficeRoutes from "../VirtualOffice/TeamVirtualOfficeRoutes";
import VirtualOfficeInviteBanner from "../../components/VirtualOfficeInviteBanner";
import { POPUP_TEAM_BASE } from "../../utils/teamNavigation";

const VirtualOfficePopup = () => (
  <Box
    sx={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      bgcolor: "background.default",
    }}
  >
    <VirtualOfficeInviteBanner />
    <TeamVirtualOfficeRoutes basePath={POPUP_TEAM_BASE} standalone />
  </Box>
);

export default VirtualOfficePopup;
